export default __webpack_public_path__ + "locales/ro/UploadPanel.json?hash=23ac0875a31e96d3eaf12389f6da5af1";